import script from "./MessageHeaders.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageHeaders.vue?vue&type=script&lang=ts&setup=true"

import "./MessageHeaders.vue?vue&type=style&index=0&id=acab0860&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\tformCommunicationViewer_develop\\frontend\\.yarn\\__virtual__\\vue-loader-virtual-12f41bf58f\\5\\YarnPackageCache\\vue-loader-npm-17.0.0-6ebaa2d3c5-a6eb675f07.zip\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acab0860"]])

export default __exports__